import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/strategy_undefined.png'


const _hoisted_1 = {
  key: 0,
  class: "useful-link-block"
}
const _hoisted_2 = { class: "useful-links-list" }
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["alt"]
const _hoisted_9 = { class: "label" }

import enUK from "@/locales/home/en-UK.json";

import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import useMutationHandlers from "@/composables/useMutationHandlers";
import { GET_PROJECT_RESOURCES } from "@/graphql/project/queries";
import EmbeddedBoard from "@/components/EmbeddedBoard.vue";
import {
  ProjectResourcesCategory,
  ProjectResourcesType,
} from "@/helpers/project/typesDefinition";

type MessageSchema = typeof enUK;

interface Props {
  id?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectWorkReporting',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const { createErrorHandler } = useMutationHandlers();

const { result: projectResourcesResult, onError: onProjectResourcesError } =
  useQuery(GET_PROJECT_RESOURCES, () => ({
    projectId: props.id,
  }));
onProjectResourcesError(createErrorHandler("getProjectResources"));

const projectResources = computed(() => {
  return projectResourcesResult.value?.projectResources ?? [];
});

const reportingResources = computed(() => {
  return projectResources.value.filter(
    (resource) => resource.category === ProjectResourcesCategory.REPORTING,
  );
});

const embeddedResources = computed(() => {
  return reportingResources.value.filter(
    (resource) => resource.type === ProjectResourcesType.EMBEDDED,
  );
});

const urlResources = computed(() => {
  return reportingResources.value.filter(
    (resource) => resource.type === ProjectResourcesType.URL,
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (urlResources.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_unref(t)("labels.usefulLinks")), 1),
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urlResources.value, (resource) => {
              return (_openBlock(), _createElementBlock("li", {
                key: resource.id
              }, [
                _createElementVNode("a", {
                  href: resource.link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: resource.tooltip
                }, _toDisplayString(resource.label ?? resource.link), 9, _hoisted_3)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(embeddedResources.value, (resource) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "embedded-block",
          key: resource.id
        }, [
          (resource.label)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(resource.label), 1))
            : _createCommentVNode("", true),
          (resource.tooltip)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(resource.tooltip), 1))
            : _createCommentVNode("", true),
          _createVNode(EmbeddedBoard, {
            class: "embedded-board",
            resource: resource
          }, null, 8, ["resource"])
        ]))
      }), 128)),
      (!embeddedResources.value.length && !urlResources.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _unref(t)('architectureImage.default.alt')
            }, null, 8, _hoisted_8),
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(t)("resources.default.label")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})